import { useMutation } from 'react-query'
import { type TaskLinkAndUnlinkCollaboratorPersistence } from '../../../../types/persistence/task-link-and-unlink-collaborator-persistence'
import { api } from '../../../api'

const taskUnlinkCollaborator = async (id: number, data: TaskLinkAndUnlinkCollaboratorPersistence) => {
  const response = await api.put(`/tasks/${id}/unlink-collaborator`, data)
  return response.data
}

export const useTaskUnlinkCollaboratorMutation = () => {
  return useMutation({
    mutationFn ({ id, data }: { id: number, data: TaskLinkAndUnlinkCollaboratorPersistence }) {
      return taskUnlinkCollaborator(id, data)
    }
  })
}
